import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";
import { localStateSelector, makeForumOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const forumOptionsSelector = makeForumOptionsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      hasForums: forumOptionsSelector(state, props).length > 0,
      view: localState.showingPostId ? "detail" : "list"
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
